import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { api } from './services/api';
import authReducer from './features/authSlice';
import droneLiveReducer from './features/droneLiveSlice';
import simulationLiveReducer from './features/simulationLiveSlice';
import { setupListeners } from '@reduxjs/toolkit/query';
import { droneWebSocketMiddleware } from './middleware/droneWebSocketMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    droneLive: droneLiveReducer,
    simulationLive: simulationLiveReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware, droneWebSocketMiddleware),
});
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
